import React, { Dispatch, SetStateAction } from "react";

export const initialFilterOptions = {
  productSampleIds: [] as number[],
  substrateSampleIds: [] as number[],
  testMethodReferences: [] as { id: number; version: number }[],
};

export interface TestSeriesDialogContextType {
  showExcludedTests: boolean;
  setShowExcludedTests: Dispatch<SetStateAction<boolean>>;
  filterOptionsForHistoricalTestCases: typeof initialFilterOptions;
  setFilterOptionsForHistoricalTestCases: Dispatch<SetStateAction<typeof initialFilterOptions>>;
  loadingHistoricalTestCases: boolean;
  setLoadingHistoricalTestCases: Dispatch<SetStateAction<boolean>>;
  historicalTestCasesMatchCounter: number;
  setHistoricalTestCasesMatchCounter: Dispatch<SetStateAction<number>>;
}

export const TestSeriesDialogContext = React.createContext<TestSeriesDialogContextType>({
  showExcludedTests: false,
  setShowExcludedTests: () => {},
  filterOptionsForHistoricalTestCases: initialFilterOptions,
  setFilterOptionsForHistoricalTestCases: () => {},
  loadingHistoricalTestCases: true,
  setLoadingHistoricalTestCases: () => {},
  historicalTestCasesMatchCounter: 0,
  setHistoricalTestCasesMatchCounter: () => {},
});

export default TestSeriesDialogContext;
